export function subscribeIfAvailable(
  target: Record<string, unknown> | undefined,
  methodName: string,
  handler: (payload: unknown) => void,
): { subscribed: boolean; note?: string } {
  if (!target) {
    return { subscribed: false, note: 'Client unavailable' };
  }

  const method = target[methodName];
  if (typeof method !== 'function') {
    return { subscribed: false, note: 'UNAVAILABLE IN INSTALLED SDK' };
  }

  try {
    (method as (callback: (payload: unknown) => void) => unknown).call(
      target,
      handler,
    );
    return { subscribed: true };
  } catch (error) {
    return { subscribed: false, note: String(error) };
  }
}
